import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { OrdinazioniPage } from '../ordinazioni/ordinazioni';
import { ProdottiPage } from '../prodotti/prodotti';
import { InforistorantePage } from '../inforistorante/inforistorante';
import { UtentiPage } from '../utenti/utenti';
import { OrarioPage } from '../orario/orario';
import { CapconsegnaPage } from '../capconsegna/capconsegna';
import { UtenticlientPage } from '../utenticlient/utenticlient';
import { Events } from 'ionic-angular';
import { ValutazionePage } from '../valutazione/valutazione';

@Component({
  selector: 'page-tabs',
  templateUrl: 'tabs.html',
})
export class TabsPage {
  nameStore;
  tab1Root: any = OrdinazioniPage;
  tab2Root: any = ProdottiPage;
  tab3Root: any = ValutazionePage;
  tab4Root: any = InforistorantePage;
  tab5Root: any = UtentiPage;
  tab6Root: any = OrarioPage;
  tab7Root: any = CapconsegnaPage;
  tab8Root: any = UtenticlientPage;


  myIndex: number;
  user;
  constructor(navParams: NavParams,
    public events: Events
  ) {
    // Set the active tab based on the passed index from menu.ts
    this.myIndex = navParams.data.tabIndex || 0;
    this.events.subscribe('nameStore:updated', (nameStore) => {
      this.nameStore=nameStore;
 
     });
  }
}


// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts